(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-data/members/assets/javascripts/services/leave-team.js') >= 0) return;  svs.modules.push('/components/marketplace-data/members/assets/javascripts/services/leave-team.js');
"use strict";


const jupiter = svs.core.jupiter;
const leaveTeam = function (groupId) {
  let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : () => {};
  if (typeof groupId !== 'number') {
    throw new Error("groupId: ".concat(groupId, " was not a number"));
  }
  jupiter.delete("/player/1/marketplace/groups/".concat(groupId), () => {
    callback();
  }, error => {
    callback(error.responseJSON.error);
  });
};
setGlobal('svs.components.marketplaceData.members.services.leaveTeam', leaveTeam);

 })(window);